import React from "react";
import ModalBlank from "./ModalBlank";

export default function ModalImage({
  modalOpen,
  setModalOpen,
  image,
  setImage,
}) {
  return (
    <ModalBlank
      id="news-modal"
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      setData={setImage}
    >
      <div className="relative p-3">
        <img className="w-full" src={image} alt="Image" />
        {/* Close button */}
        <button
          className="absolute top-0 right-0 mt-5 mr-5 text-gray-50 hover:text-white"
          onClick={(e) => {
            e.stopPropagation();
            setImage(null);
            setModalOpen(false);
          }}
        >
          <div className="sr-only">Close</div>
          <svg className="w-4 h-4 fill-current">
            <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
          </svg>
        </button>
      </div>
    </ModalBlank>
  );
}
